<template>
    <EmployeeTableJobDetail></EmployeeTableJobDetail>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EmployeeTableJobDetail = defineAsyncComponent(() =>
    import("../../components/Hr/EmployeeJobDetail/Table.vue")
);

export default {
    name: "EmployeesJobDetail", //The name you are in should not equal the name of the component you are importing.
    components: { EmployeeTableJobDetail, AuthLayout },
};
</script>

<style scoped></style>
